// Color
const color = [
    { key: 'b', value: 'black', title: 'Black' },
    { key: 'w', value: 'white', title: 'White' },
    { key: 't', value: 'transparent', title: 'Transparent' }
];
exports.color = color;
